import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default class extends Controller {
  connect() {
    this.handleResize();
  }

  initializeSwiper() {
    this.swiper = new Swiper(".js-banner-slider-small", {
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      lazy: true,
      loop: true,
      spaceBetween: 8,
      speed: 300,
      slidesPerView: "auto",
      pagination: {
        el: ".js-banner-slider-small-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".js-banner-slider-small-next",
        prevEl: ".js-banner-slider-small-prev",
      },
      // キーボード操作
      keyboard: {
        enabled: true,
      },
    });
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = undefined;
    }
  }

  handleResize() {
    var slideCount = $(".js-banner-slider-small").find(".swiper-slide").length;

    if (slideCount <= 2) {
      this.destroySwiper();
    } else {
      if (!this.swiper) {
        this.initializeSwiper();
      }
    }
  }

  //再生/停止ボタン
  sliderstop(e) {
    if (this.swiper) {
      if ($(e.currentTarget).hasClass("is-pause")) {
        this.swiper.autoplay.start();
        $(e.currentTarget).removeClass("is-pause");
        $(e.currentTarget).text("停止する");
      } else {
        this.swiper.autoplay.stop();
        $(e.currentTarget).addClass("is-pause");
        $(e.currentTarget).text("再生する");
      }
    }
  }
}
